module.exports = __webpack_public_path__ + "fepro/img/identity_success@2x.d8d4a36e.png";